import FavoriteEditorPage from 'features/menu/pages/favorites-page/favorite-editor/favorite-editor';

export default function FavoriteEditor() {
  return <FavoriteEditorPage />;
}
